import type { FC, ReactNode } from 'react';

import { Box } from '@zillow/constellation-10';

interface TourCardContentContainerProps {
  children: ReactNode;
  size?: 'sm' | 'md';
}

const TourCardContentContainer: FC<TourCardContentContainerProps> = ({ children, size = 'sm' }) => (
  <Box
    css={{
      borderTop: '1px solid {colors.border.subtle}',
      display: 'flex',
      flexDirection: 'column',
      padding: size === 'sm' ? '200' : '400',
    }}
  >
    {children}
  </Box>
);

export type { TourCardContentContainerProps };
export default TourCardContentContainer;
